import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
// import './Currency.css';
import Slider from 'react-slick';
// import marketup from '../../Images/arrow-up.png';
// import marketdown from '../../../Images/Images/arrow-down.png';
import { useNavigate } from "react-router-dom";
import { Vortex } from 'react-loader-spinner'


function MfTopHoldings() {
    const { BaseURL } = useContext(URLstateContext);
    const [DataMfHolding, setDataMfHolding] = useState([]);
    const [DataMfHoldingdrop, setDataMfHoldingdrop] = useState([]);
    const [DataMfHoldingdropcat, setDataMfHoldingdropcat] = useState([]);
    const [Category, setCategory] = useState('5946');
    const [Sheme, setSheme] = useState('26');
    const [ShemeCode, setShemeCode] = useState('10645');
    const [DataMfHoldingdropSheme, setDataMfHoldingdropSheme] = useState([]);
    const [valueschemename, setValueschemename] = useState([]);
    const [valuecategory, setValuecategory] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    const [valuecode,setvaluecode] = useState([]);
    let  getDataHolding, getDataHoldingdrop,
        getDataHoldingdropcat, getDataHoldingdropSheme;
        let navigate = useNavigate();
        useEffect(() => {
            setloadingshow(true);
            const getUrlMfTopHoldingDrop = BaseURL + "MfHoldingDrop";
            // alert(`getUrlMfTopHoldingDrop/-/-`)
            // alert(`${getUrlMfTopHoldingDrop}/-/-`)
            // alert(`${getUrlMfTopHoldingDrop}/-/-`)
            fetch(`${getUrlMfTopHoldingDrop}/-/-`)
                .then((response) => response.json())
                .then((dataMHoldingdrop) => {
                    getDataHoldingdrop = dataMHoldingdrop.data;
                    setDataMfHoldingdrop(getDataHoldingdrop);
                    var schemename = getDataHoldingdrop[0].co_name;
                setValueschemename(schemename)
                setloadingshow(false);
                    //console.log(getDataHoldingdrop, "MfHoldingDrop")
                })
                .catch((error) => {
                });
                // alert(`${getUrlMfTopHoldingDrop}/${Category}/-`)
            fetch(`${getUrlMfTopHoldingDrop}/${Category}/-`)
                .then((response) => response.json())
                .then((dataMHoldingdropcat) => {
                    getDataHoldingdropcat = dataMHoldingdropcat.data;
                    setDataMfHoldingdropcat(getDataHoldingdropcat);
                    var categoryname = getDataHoldingdropcat[0].VCLASS;
                setValuecategory(categoryname)
                setloadingshow(false);
                    //console.log(getDataHoldingdropcat, "MfHoldingDropcat")
                })
                .catch((error) => {
                });

            // alert(`${getUrlMfTopHoldingDrop}/${Category}/${Sheme}`)
            fetch(`${getUrlMfTopHoldingDrop}/${Category}/${Sheme}`)
                .then((response) => response.json())
                .then((dataMHoldingdropSheme) => {
                    getDataHoldingdropSheme = dataMHoldingdropSheme.data;
                    setDataMfHoldingdropSheme(getDataHoldingdropSheme);
                    var codename = getDataHoldingdropSheme[0].SCH_NAME;
                    setvaluecode(codename)
                    setloadingshow(false);
                    // console.log(codename)
                    //console.log(getDataHoldingdropSheme, "MfHoldingDropSheme")
                })
                .catch((error) => {
                });
    
            const getUrlMfTopHolding = BaseURL + "MfTopHolding";
            fetch(`${getUrlMfTopHolding}/${ShemeCode}/8`)
                .then((response) => response.json())
                .then((dataMHolding) => {
                    getDataHolding = dataMHolding.data;
                    setDataMfHolding(getDataHolding);
                    setloadingshow(false);
                    //console.log(getDataHolding, "MfTopHolding")
                })
                .catch((error) => {
                });
        }, [Category, Sheme, ShemeCode]);
        return (
        <>
            <div className='market-inner-common market-mf-main'>
                <div className='market-header'>
                    <h4>Top 10 Holdings</h4>
                    <span className="moreContent" onClick={()=>{navigate("/MutualFund/Top-10-Holding")}} tabIndex={0} >See More</span>
                </div>
                <Container className="add-border table-box">
                <div className='mf-common top-10'>
                    <div className='holdings-select'>
                        {/* aria-label="Select Fund House" */}
                        <select aria-label="Select Fund House" onChange={(event) => setCategory(event.target.value)}>
                            <option>Select Fund House</option>
                            {DataMfHoldingdrop && DataMfHoldingdrop.map(
                                ({ mf_cocode, co_name }) => (
                                    <option value={mf_cocode} selected={valueschemename === co_name}>{co_name}</option>
                                )
                            )}
                        </select>
                    </div>
                    <div className='holdings-select'>
                        {/* aria-label="Select Category" */}
                        <select aria-label="Select Category" onChange={(event) => setSheme(event.target.value)}>
                            <option>Select Category</option>
                            {DataMfHoldingdropcat && DataMfHoldingdropcat.map(
                                ({ VCLASSCODE, VCLASS }) => (
                                    <option value={VCLASSCODE} selected={valuecategory === VCLASS}>{VCLASS}</option>
                                )
                            )}
                        </select>
                    </div>
                    <div className='holdings-select'>
                        {/* aria-label="Select Scheme" */}
                        <select aria-label="Select Scheme" onChange={(event) => setShemeCode(event.target.value)}>
                            <option>Select Scheme</option>
                            {DataMfHoldingdropSheme && DataMfHoldingdropSheme.map(
                                ({ MF_SCHCODE, SCH_NAME }) => (
                                    <option value={MF_SCHCODE} selected={valuecode === SCH_NAME}>{SCH_NAME}</option>
                                )
                            )}
                        </select>
                    </div>
                    <div className='mf-table table-responsive gainer-table'>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th className='text-left'>Company Name</th>
                                    <th className='text-right'>% Hold</th>
                                </tr>
                            </thead>
                            {(DataMfHolding === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                            <tbody>
                                {(DataMfHolding != null) && DataMfHolding.map(
                                    ({ co_code, co_name, Perc_hold }) => (
                                        <tr>
                                            <td className='text-left'>{co_name}</td>
                                            <td className='text-right'>{Perc_hold.toFixed(2)}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                        {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                    </div>
                </div>
                </Container>
            </div>
        </>
    )
}

export default MfTopHoldings